import SearchPolicyBox from './SearchPolicyBox'

export default SearchPolicyBox
